import * as React from 'react'

export default ({ ...props }) => (
  <pre>
    {JSON.stringify(props, null, 2)}
  </pre>
)
